import { Directive, ElementRef, Input, Renderer } from '@angular/core';

declare var Holder: any;

@Directive({
  selector: '[holder]'
})
export class HolderDirective {

  @Input('size') size: any;

  constructor(private elRef: ElementRef, private renderer: Renderer) {
    renderer.listen(elRef.nativeElement, 'error', (e) => {
      elRef.nativeElement.dataset.src = `holder.js/${this.size.w}x${this.size.h}?text=Waiting for photo`;
      Holder.run({
        images: elRef.nativeElement,
        themes: {
          default: {
            font: 'Muli',
            size: 9,
            fontweight: 'lighter'
          }
        }
      });
    });
  }
}
